import React from "react";
import Icon from "../../components/atoms/Icon";
import Select from "react-dropdown-select";
import { OrderAddUseContext } from "../../context/AdminDashboard/OrderAddContext";

const SearchOrder = ({ placeholder, gettext,  }) => {
  const { Loading, onchange, onchangeopt, productopt ,buttonSearch,selectRef } = OrderAddUseContext();
  const customNoDataRenderer = () => {
    return <div style={{ display: "none", border:"none" }}></div>;
  };
  return (
    <>
      <form className="flex w-full items-center ">
        <label htmlFor="simple-search" className="sr-only">
          Search
        </label>
        <div className="relative w-full flex flex-row  border-gray border-2 rounded-sm justify-between h-10">
          <div className="absolute inset-y-0 right-5  flex items-center pl-3 pointer-events-none">
            <Icon iconName="search-normal2" />
          </div>
          {/* <input
          type="text"
          className="pr-12  text-dark-blue-200 bg-gray-100 placeholder:text-gray-200   block   text-12 outline-none w-full"
          placeholder={"جست و جو: نام دستگاه"}
         onChange={gettext}
        /> */}
          <div className="w-full">
            <Select
              style={{
                border:"none",
                width:"auto",
                border: "none",
                fontSize: "12px ",
                padding: "10px 15px ",
                alignItems: "center",
                marginRight: "30px",
                direction: "rtl",
              }}
              searchable={true}
              placeholder="جست و جو: نام دستگاه"
              onChange={onchangeopt}
              searchFn={!Loading ? onchange : undefined}
              options={productopt}
              noDataRenderer={customNoDataRenderer}
               closeOnSelect={true}
               ref={selectRef}
              dropdownHandleRenderer={({ state }) => (
                // if dropdown is open show "–" else show "+"
                <span></span>
              )}
            />
          </div>

          <button
            className="px-3.5 text-dark-blue-200 text-12 border-r-2 border-gray mt-2.5 mb-2.5 "
            onClick={buttonSearch}>
            ثبت
          </button>
        </div>
      </form>
    </>
  );
};

export default SearchOrder;
